import { SearchModel } from '@/components/RunsTable/types';

export type AlertType = 'threshold' | 'change';

export enum AlertAttribute {
  error_count = 'error_count',
  latency = 'latency',
  feedback_score = 'feedback_score',
  run_count = 'run_count',
  run_latency = 'run_latency',
}

export type AlertAggregation = 'sum' | 'avg' | 'pct';
export enum AlertActionTarget {
  pagerduty = 'pagerduty',
  webhook = 'webhook',
}
export type AlertOperator = 'gte' | 'lte';
export type AlertPagerDutySeverityLevel =
  | 'critical'
  | 'error'
  | 'warning'
  | 'info';
export interface AlertRule {
  id?: string;
  name: string;
  description: string;
  type: AlertType;
  attribute: AlertAttribute;
  aggregation: AlertAggregation;
  window_minutes: 5 | 15;
  operator: AlertOperator;
  threshold: number | null;
  threshold_window_minutes: number | null;
  threshold_multiplier: number | null;
  filter: string | null;
  denominator_filter: string | null;
}

export interface AlertAction {
  id?: string;
  alert_rule_id?: string;
  target: AlertActionTarget;
  config: string; // JSON string containing key-value pairs for action configuration
}

export interface AlertRuleWithActions {
  rule: AlertRule;
  actions: AlertAction[];
}

export interface CreateAlertRequest {
  rule: AlertRule;
  actions: AlertAction[];
}

export interface UpdateAlertRequest {
  rule: AlertRule;
  actions: AlertAction[];
}

export interface TestAlertRequest {
  rule: AlertRule;
  actions: AlertAction[];
}

export interface AlertsResponse {
  session_alert_rules: AlertRuleWithActions[];
}

export interface PagerDutyConfig {
  integration_key: string;
  severity: string;
}

export interface WebhookConfig {
  url: string;
  method: string;
  headers: string; // JSON string
  body: string; // JSON string
  project_name: string;
}

export interface AlertBuilderBanner {
  title: string;
  msg: string;
  status: 'error' | 'success';
}

export interface AlertBuilder {
  id?: string;
  name: string;
  description: string;
  type: AlertType;
  attribute: AlertAttribute;
  aggregation: AlertAggregation;
  windowMinutes: '5' | '15';
  operator: AlertOperator;
  threshold: string;
  isThresholdValid: boolean;
  feedbackKey: string;
  filter: SearchModel;
  actionTarget: AlertActionTarget;
  pagerDutyConfig?: {
    id?: string;
    severity?: AlertPagerDutySeverityLevel;
    integration_key?: string;
    secret_name?: string;
  };
  webhookConfig?: {
    id?: string;
    url?: string;
    headers?: string;
    body?: string;
    project_name?: string;
  };
  banner?: AlertBuilderBanner;
}
